/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
// import PropTypes from 'prop-types';
import { useLazyQuery } from 'react-apollo';
import mbpLogger from 'mbp-logger';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
    func, shape, string, object,
} from 'prop-types';
import findProductPageByPartNumber from '../../../../../gql/queries/findProductPageByPartNumber';
import GraphqlPortalLoader from '../../../GraphqlCommonComponents/GraphqlPortalLoader';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

// Higher Order Component that redirects to the Selected Upsell.
// children gets a function that can be triggered onClick that redirects to upsell
const RedirectToSku = ({
    children: Component,
    selectedSkuId,
    onChange,
    brand,
    history,
}) => {
    const FIND_PDP_BY_PART = findProductPageByPartNumber(brand['domain-name'], selectedSkuId);
    const [loadPDP, { errorPDP, loading, data }] = useLazyQuery(FIND_PDP_BY_PART);

    if (loading) {
        return <GraphqlPortalLoader />;
    }

    if (errorPDP) {
        return mbpLogger.logError({ message: `error prefetching PDP  ${errorPDP}` });
    }

    if (data) {
        const productURL = data?.findProductPageByPartNumber?.product?.seo?.url || null;
        history.push({
            pathname: productURL,
        });
    }

    const handleSkuChange = (event, sku) => {
        const modifiedEvent = event;
        modifiedEvent.target.value = sku.id;
        onChange(modifiedEvent);
        loadPDP();
    };

    return (
        <Component redirectToSku={handleSkuChange} />
    );
};

RedirectToSku.propTypes = {
    selectedSkuId: string.isRequired,
    children: func.isRequired,
    brand: shape({
        'domain-name': string,
    }),
    history: object.isRequired,
    onChange: func.isRequired,
};

RedirectToSku.defaultProps = {
    brand: {
        'domain-name': 'harryanddavid',
    },
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

export default connect(mapStateToProps)(withRouter(RedirectToSku));
